
import { Vue, Component } from "vue-property-decorator";
import editor from "./editor";
import { translit } from "@/cms-services/helpers";
@Component({
  mixins: [editor],
})
export default class SystemNameInlineEditor extends Vue {
  dataSource: any;
  value: any;
  config: any;
  generateSystemName() {
    const bindedFieldName = this.config?.bindedFieldName ?? "caption";
    const caption = this.dataSource?.model[bindedFieldName];
    if (!caption) return;
    this.value = translit(caption);
  }
}
